module.exports = function getResource(label, vars = []) {
    const resources = {
        straighteningLabel: 'Raidissant',
        beingLabel: 'être'
    };

    return resources[label];
};
